const CHUNK_RELOAD_KEY = 'fw_chunk_reload';

const STALE_ASSET_PATTERNS = [
    'Unable to preload CSS',
    'Loading chunk',
    'Loading CSS chunk',
    'Failed to fetch dynamically imported module',
    'Importing a module script failed',
    'error loading dynamically imported module',
] as const;

function getErrorMessage(reason: unknown): string {
    if (reason instanceof Error) {
        return reason.message;
    }

    return reason != null ? String(reason) : '';
}

export function isStaleAssetError(reason: unknown): boolean {
    const message = getErrorMessage(reason);

    return STALE_ASSET_PATTERNS.some((pattern) => message.includes(pattern));
}

export function handleStaleAssetError(reason: unknown): boolean {
    if (!isStaleAssetError(reason)) {
        return false;
    }

    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
        return true;
    }

    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();

    return true;
}

export function clearStaleAssetReloadFlag(): void {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}

export function initStaleAssetReloadHandlers(): void {
    window.addEventListener('unhandledrejection', (event) => {
        if (!handleStaleAssetError(event.reason)) {
            return;
        }

        event.preventDefault();
    });

    window.addEventListener('error', (event) => {
        if (!handleStaleAssetError(event.error ?? event.message)) {
            return;
        }

        event.preventDefault();
    });
}
